import { DemoForm } from "./DemoForm";

export const DemoSection = () => (
  <section id="demo" className="cd-section border-t border-[#bdbdb4] bg-[#efefe6]" data-testid="demo-section">
    <div className="mx-auto grid max-w-[1360px] gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <h2 className="font-display text-3xl font-semibold leading-[1.1] tracking-[-0.025em] text-[#292929] sm:text-4xl lg:text-[44px]" data-testid="demo-title">
          Book a demo
        </h2>
      </div>
      <div className="cd-reveal lg:col-span-7">
        <DemoForm />
      </div>
    </div>
  </section>
);
